<template>
  <div class="woo-video-overlays">
    <div class="woo-video-text-overlays">
      <div
        v-for="(overlay) in textOverlays"
        :key="overlay.id"
        v-html="overlay.text"
        class="woo-video-overlay" :class="{
          large: overlay.isLarge,
          small: overlay.isSmall,
          bordered: overlay.isBordered
        }"
        :style="{
          'text-align': overlay.text_alignment || 'center',
        }"/>
    </div>
    <div class="woo-video-link-overlays">
      <a v-for="(overlay) in linkOverlays" :key="overlay.id" target="_blank" :href="overlay.url">
        <div
          class="woo-video-overlay animate__animated animate__fadeInUp animate__faster"
          :class="{
            large: overlay.isLarge,
            small: overlay.isSmall
          }"
          :style="{
            'text-align': overlay.text_alignment || 'center',
          }"
        >
          <v-icon class="woo-link-icon">mdi-link</v-icon>
          {{overlay.text}}
        </div>
      </a>
    </div>
  </div>
</template>
<script>
import { GUIDES, OVERLAY_SIZE } from '@/constants';
import Db from '@/helpers/Db';

const getOverlays = ({ isBordered, overlays, type }) => {
  return overlays
  .filter(a => {
    if (type === 'link') return a.url;
    return !a.url;
  })
  .map(o => ({
    ...o,
    isLarge: !o.url && o.size === OVERLAY_SIZE.L,
    isSmall: !o.url && o.size === OVERLAY_SIZE.S,
    isBordered: isBordered || o.white_outline,
  }));
}

export default {
  name: 'VideoOverlay',
  computed: {
    tutorial() {
      return Db.getFullTutorialBySlug(this.$route.params.id)
    },
    textOverlays() {
      return getOverlays({
        overlays: this.$attrs.overlays,
        isBordered: this.tutorial.id === GUIDES.STEVE_THE_FRANKENSTEIN.id
      });
    },
    linkOverlays() {
      return getOverlays({
        overlays: this.$attrs.overlays,
        type: 'link'
      });
    },
  },
}
</script>

<style lang="scss" scoped>
  .woo-video-overlays {
    font-weight: bold;
    font-size: 22px;
    line-height: 1.2em;
    padding: 0px 20px;
    text-align: center;
    position: absolute;
    top: 100px;
    width: 100%;
    z-index: 1000;

    .woo-video-overlay {
      // background-color: rgba(255, 255, 255, 0.7);
      border-radius: 0.25em;
      padding: 0px 10px;
      display: table;
      margin: auto;
      margin-bottom: 7px;
      letter-spacing: -1px;
      
      &.large {
        font-size: 30px;
        font-weight: 900 !important;
        letter-spacing: -2px;
        line-height: 1.1em;
      }

      &.small {
        font-size: 16px;
        line-height: 1.2em;
      }

      &.bordered {
        text-shadow: 1px 0 #eee, -1px 0 #eee, 0 1px #eee, 0 -1px #eee, 1px 1px #eee, -1px -1px #eee, 1px -1px #eee, -1px 1px #eee;
      }
    }
  }

  .woo-video-link-overlays {
    font-size: 18px;
    line-height: 1.2em;
    margin-top: 17px; 

    a {
      display: flex;
      align-items: center;
    }

    a * {
      color: #fff !important;
    }

    .woo-link-icon {
      margin: -1px 4px 0px 0px;
      font-size: 24px !important; 
      display: flex;
    }

    .woo-video-overlay {
      background-color: #2CC1BC;
      border-radius: 0.25rem;
      backdrop-filter: blur(5px);
      display: flex;
      align-items: center;
      padding: 5px 10px;
      margin-bottom: 7px;
      transition: all 0.2s ease-in-out;

      &:hover {
        background-color: darken(#2CC1BC, 5);
      }
    }
  }
</style>